"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigContext = void 0;
var _react = require("react");
const ConfigContext = exports.ConfigContext = /*#__PURE__*/(0, _react.createContext)({
  layout: 'default'
});